import * as React from "react";
import {Typography} from "@mui/material";

const Tags = ({tags}) => {
    return (
        tags ?
            tags.map((tag) => (
                <span className='tags'><Typography variant={'subtitle3'}>{tag}</Typography></span>
            ))
            : ''
    )
}

export default Tags;
